import React from 'react'
import { ArrayItens } from '../../types/components/arrayItens'
import { ButtonRedirect } from '../ButtonRedirect'
import { CardStyle } from './style'

export const Card: ArrayItens = ({ job, nameButton, pathButton }) => {
  return (
    <CardStyle>
      <h2 className={job.IsActive ? '' : 'inative'}>
        {job.IsActive ? '' : '(INATIVO) - '} {job.Cargo} ({job.Modalidade})
      </h2>
      <label>
        <p className={job.IsActive ? '' : 'inative'}>Área: {job.Area}</p>
        <p className={job.IsActive ? '' : 'inative'}>Local: {job.Local}</p>
      </label>
      <ButtonRedirect link={`${pathButton}/${job._id}`} nameButton={nameButton} />
    </CardStyle>
  )
}
